import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export type BadgeTon = 'neutral' | 'info' | 'erfolg' | 'warnung' | 'gefahr';

const TOENE: Record<BadgeTon, string> = {
  neutral: 'bg-surface-2 text-fg-muted border-border',
  info: 'bg-accent-soft text-accent-soft-fg border-transparent',
  erfolg: 'bg-success-soft text-success-soft-fg border-transparent',
  warnung: 'bg-warning-soft text-warning-soft-fg border-transparent',
  gefahr: 'bg-danger-soft text-danger-soft-fg border-transparent',
};

export interface BadgeProps {
  ton?: BadgeTon;
  /** Punkt vor dem Text, z. B. für Statusanzeigen. */
  punkt?: boolean;
  children: ReactNode;
  className?: string;
}

export function Badge({ ton = 'neutral', punkt = false, children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-pill border px-2.5 py-0.5',
        'text-xs font-medium leading-5',
        TOENE[ton],
        className,
      )}
    >
      {punkt && <span className="h-1.5 w-1.5 rounded-pill bg-current" aria-hidden="true" />}
      {children}
    </span>
  );
}
